import { Route, Routes, Navigate } from "react-router-dom";
import { Layout } from "antd";
import { 
    Container,
} from "./styled";
import Header from "../../components/Header";
import Menu from "../../components/Menu";
import HomeContainer from "../../containers/HomeContainer";
import TeamProgressContainer from "containers/TeamProgressContainer";
import HazmatContainer from "containers/HazmatContainer";
import NotFoundPage from "components/404";
import { USER_ROLE } from "../../constants";

const LandingPage = () => {
    const session = JSON.parse(localStorage.getItem("session"));

    return (
        <Container>
            <Header />
            <Layout style={{marginTop: "48px"}}>
                <Menu />
                <Layout>
                    <Layout.Content>
                        <Routes>
                            {session.role !== USER_ROLE.STUDENT && <Route path="/" element={<TeamProgressContainer />} />}
                            <Route path="/" element={<HomeContainer />} />
                            <Route path="/precimar_ulm_600_e/:id" element={<HazmatContainer />} />
                            <Route path="/login" element={<Navigate to="/" replace />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Routes>
                    </Layout.Content>
                </Layout>
            </Layout>
        </Container>
    )
}

export default LandingPage;